import React from 'react';
import classNames from 'classnames';

import Icon from 'icons/icon';

import styles from './assessment-card.less';

module.exports = React.createClass({
  displayName: 'ScheduleCard',
  propTypes: {
    className: React.PropTypes.string,
    icon: React.PropTypes.string.isRequired,
    text: React.PropTypes.string.isRequired
  },
  getClass() {
    return classNames(styles.card, this.props.className);
  },
  render() {
    return <div className={this.getClass()}>
      <div className={styles.cardText}>{this.props.text}</div>
      <Icon icon={this.props.icon} className={styles.cardIcon} />
    </div>
  }
});



/** WEBPACK FOOTER **
 ** ./src/lists/example/assessment-card/index.js
 **/